export default (
  state = {
    onBoardingModal: false,
  },
  action,
) => {
  switch (action.type) {
    case "SET_ONBOARDING_MODAL_STATUS":
      return {
        ...state,
        onBoardingModal: action.payload.active,
      };
    default:
      return state;
  }
};
